// extracted by mini-css-extract-plugin
export default {"container":"baseNode_container__NuNUj","header":"baseNode_header__6hbI6","content":"baseNode_content__Se48T"};